import { IChecklistPopulated } from "@mctypes/checklist.types";
import { Select } from "@mantine/core";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useAppSelector } from "../../../hooks";
import { useGetProjectChecklistTemplatesQuery, useGetProjectChecklistsQuery } from "./checklistRTK";
import { ChecklistStatusEnum } from "./constants";

const ChecklistSelector: React.FC = () => {
  const { checklist, selectedPnsFilterItem } = useAppSelector((state) => state.checklistReducer);
  const project = useAppSelector((state) => state.adminReducer.project);
  const [list, setList] = useState<IChecklistPopulated[]>([]);

  const history = useHistory();

  const { data: projectChecklists = [] } = useGetProjectChecklistsQuery({
    projectId: project._id,
  });

  const {
    data: projectTemplates = [],
    isLoading: templatesLoading,
    isError: templatesError,
  } = useGetProjectChecklistTemplatesQuery({
    projectId: project._id,
  });

  const goToChecklist = (checklistId: string) => {
    history.push(`/project/${project._id}/checklist/instance/${checklistId}`);
  };

  const goToChecklistSelection = () => {
    history.push(`/project/${project._id}/checklist`);
  };

  const handleSelectChange = (checklistId: string | null) => {
    if (checklistId === "selection") {
      goToChecklistSelection();
    } else if (checklistId) {
      goToChecklist(checklistId);
    }
  };

  useEffect(() => {
    let checklists = checklist.isTemplate === true ? projectTemplates : projectChecklists;

    const filteredLists = checklists?.filter(
      (checklist) =>
        checklist.status !== ChecklistStatusEnum.REMOVED &&
        checklist.status !== ChecklistStatusEnum.DELIVERED &&
        checklist.templateType !== "MC",
    );

    setList(filteredLists);
  }, [projectTemplates?.length > 0]);

  return (
    <>
      {list.length > 0 && (
        <Select
          w="lg"
          size="sm"
          value={checklist?._id || "selection"}
          onChange={handleSelectChange}
          placeholder={checklist?.name || "Velg sjekkliste"}
          data={[
            ...list.map((cl) => ({
              value: cl._id,
              label: cl.name,
            })),
            { value: "selection", label: "Gå til Utvalg" },
          ]}
          style={{ minWidth: "200px" }}
          searchable
        />
      )}
    </>
  );
};

export default ChecklistSelector;
